interface ILinks {
  HEADER: {
    HELP_AND_SUPPORT: string;
    SEARCH: string;
    LOGIN: string;
  };
}

export const LINKS: ILinks = {
  HEADER: {
    HELP_AND_SUPPORT: "/help-support",
    SEARCH: "/search-results.html",
    LOGIN: "/auth/callback",
  },
};
